export const WORKER_PATH = 'pushy-service-worker.js'
export const APP_ID = import.meta.env.VITE_PUSHYME_APP_ID || ''
